<p>create-loan-failure</p>
